import createURL, { handleJSONResponse } from "./api";
import {
  FetchResponse,
  LoginParams,
  RegisterParams,
  Location,
  DirectusErrors,
} from "./type";

const API_HOST = process.env.NEXT_PUBLIC_API_HOST ?? "";

/** next登录处理 */
export const postNextLogin = async (params: FormData) => {
  return await fetch(`/next/login`, {
    method: "POST",
    body: params,
  }).then((res) => {
    // return handleJSONResponse(res) as Promise<
    //   | {
    //       message: string;
    //       data: {
    //         access_token: string;
    //         refresh_token: string;
    //         expires: number;
    //       };
    //     }
    //   | {
    //       code: string;
    //       message: string;
    //     }
    // >;
    return res.json();
  });
};

/** 用户登录 */
export const postLogin = async (params: LoginParams) => {
  return await fetch(`${API_HOST}/customers/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...params }),
  }).then((res) => {
    return handleJSONResponse(res, {
      errors: [
        {
          extensions: {
            code: "10000",
          },
          message: "请求失败",
        },
      ],
    });
  });
};

/** 获取邮箱验证码 */
export const postEmailCode = async (params: {
  email: string;
  language: string;
}) => {
  return await fetch(`${API_HOST}/customers/verificationCode`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...params }),
  }).then((res) => {
    return handleJSONResponse(res) as Promise<{
      data: string;
    } | DirectusErrors>
  });
};

/** 获取手机验证码 */
export const postPhoneCode = async (params: {
  phoneArea: string;
  phoneNumber: string;
  language: string;
}) => {
  return await fetch(`${API_HOST}/customers/verificationSMS`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...params }),
  }).then((res) => {
    return handleJSONResponse(res) as Promise<{
      data: string;
    } | DirectusErrors>;
  });
};

/** 用户注册 */
export const postRegister = async (
  params: RegisterParams
): Promise<
  | {
      data: string;
    }
  | DirectusErrors
> => {
  return await fetch(`${API_HOST}/customers/registry`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...params }),
  }).then((res) => {
    return handleJSONResponse(res, {
      errors: [
        {
          extensions: {
            code: "10000",
          },
          message: "请求失败",
        },
      ],
    }) as Promise<
      | {
          data: string;
        }
      | DirectusErrors
    >;
  });
};

/** 获取国家数据 */
export const getCountry = async (params?: {
  filter: Record<string, any>;
  fields?: string;
}) => {
  return await fetch(
    createURL(`/items/location`, {
      fields: params?.fields ?? "*",
      filter: JSON.stringify(params?.filter),
      limit: -1,
    })
  ).then((res) => {
    return handleJSONResponse<FetchResponse<Location[]>>(res) as Promise<
      FetchResponse<Location[]>
    >;
  });
};

/** 获取图形验证码 */
export const getImageCaptcha = async (params: { identifier?: string }) => {
  return await fetch(`${API_HOST}/customers/captcha`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...params }),
  }).then((res) => {
    return handleJSONResponse(res) as Promise<{
      expired: number;
      image: string;
    }>;
  });
};

/** 验证图形验证码 */
export const postImageCaptcha = async (params: {
  identifier: string;
  captcha: string;
}) => {
  return await fetch(`${API_HOST}/customers/captcha/verify`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...params }),
  }).then((res) => {
    return handleJSONResponse(res) as Promise<{
      success: boolean;
    }>;
  });
};

/** 重置密码 */
export const postResetPassword = async (params: {
  password: string;
  code: string;
  captcha: string;
  identifier: string;
  email?: string;
  phoneNumber?: string;
  phoneArea?: string;
  organization?: string;
  position?: string;
  location?: number;
  city?: number;
}) => {
  return await fetch(`${API_HOST}/customers/password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...params }),
  }).then((res) => {
    return handleJSONResponse(res) as Promise<{
      data: string;
    } | DirectusErrors>;
  });
};

/** 获取用户信息 */
export const getCustomer = async (token: string) => {
  return await fetch(
    createURL(`/users/me`, {
      fields: [
        "id,front_user_email,email,first_name,role.front_permissions.action,role.id,role.name,role.level,phone_number,phone_area,organization,position,location,city",
      ],
    }),
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  ).then((res) => {
    return handleJSONResponse<FetchResponse<any>>(res) as Promise<
      FetchResponse<any>
    >;
  });
};
